import { JsonSchema, RowData } from "../../../../types";
import {
  ExportContext,
  ParentExportRow,
  ParentIdentifier,
} from "../../../../types/types.export";
import { SETUP_IDENTIFIER_FIELDS } from "../../constants";
import { getSchemaSections } from "../schemaHelpers";

export const getParentIdentifier = (
  context: ExportContext,
): ParentIdentifier => {
  const fields = SETUP_IDENTIFIER_FIELDS[context.schema.title] ?? [];

  return {
    key: "",
    fields,
  };
};

export const buildParentExportRows = (
  rowDataList: RowData[],
  context: ExportContext,
): ParentExportRow[] => {
  const identifier = getParentIdentifier(context);

  return rowDataList.map((row) => ({
    row,
    identifier: {
      ...identifier,
      key: identifier.fields.map((field) => String(row[field] ?? "")).join("|"),
    },
  }));
};

export const getFieldsToExportForBaseAndChild = (
  schema: JsonSchema,
): Set<string> => {
  const sections = getSchemaSections(schema);

  return new Set([...sections.flatMap((section) => section.sectionValue)]);
};
